import { useMemo } from 'react';


import { getComponents } from "./getComponents";

export function useOverrides(
defaultComponents,


overrides)
{
  const components = useMemo(
  () => getComponents(defaultComponents, overrides),
  [defaultComponents, overrides]);


  return components;
}